// @noflow
import BreedQuestionnaire from './BreedQuestionnaire'

export default BreedQuestionnaire
